import { useTranslation } from "react-i18next";
import { Package } from "lucide-react";
import { DetailCard } from "./DetailCard";
import { fmtMoney, fmtQty } from "../../../lib/format";

const H = ({ children }) => (
  <th className="border-b border-border/50 px-2 py-2 text-center text-[11px] font-bold text-muted-foreground">
    {children}
  </th>
);
const C = ({ children, className = "" }) => (
  <td className={`px-2 py-2 text-center text-xs ${className}`}>{children}</td>
);

// بنود الطلب: جدول بسيط + صف إجمالي كلي.
export const DetailItems = ({ doc }) => {
  const { t, i18n } = useTranslation();
  const lines = doc.lines || [];
  const cur = doc.money?.currency || "";
  return (
    <DetailCard tid="section-items" icon={Package}
                title={t("purchases.podetail.orderItems")}>
      <div className="overflow-x-auto rounded-xl">
        <table className="min-w-full text-xs" dir="rtl">
          <thead>
            <tr>
              <H>{t("purchases.description")}</H>
              <H>{t("purchases.qty")}</H>
              <H>{t("purchases.unit")}</H>
              <H>{t("purchases.unitPrice")}</H>
              <H>{t("purchases.lineTotal")}</H>
            </tr>
          </thead>
          <tbody>
            {lines.map((l, i) => (
              <tr key={l.line_no || i} data-testid={`row-item-${i + 1}`}
                  className="border-b border-border/30">
                <C className="text-start font-bold">
                  {(i18n.language === "ar" ? l.description_ar : null) || l.description}
                </C>
                <C><span className="num font-mono">{fmtQty(l.quantity)}</span></C>
                <C>{l.uom || "—"}</C>
                <C><span className="num font-mono">{cur} {fmtMoney(l.unit_price)}</span></C>
                <C><span className="num font-mono font-bold">{cur} {fmtMoney(l.line_total)}</span></C>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={4} className="px-2 pt-3 text-end text-xs font-bold">
                {t("purchases.podetail.totalItems")}
              </td>
              <td className="px-2 pt-3 text-center text-sm font-extrabold text-emerald-600"
                  data-testid="row-grand-total">
                <span className="num font-mono">{cur} {fmtMoney(doc.totals?.payable)}</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </DetailCard>
  );
};
